export const categories = [
  {
    slug: 'shipin-fuwu',
    name: '视频服务',
    description: '高清流畅的视频播放与直播服务，支持多终端同步观看',
    icon: 'ri-live-line',
    color: 'accent',
    featured: true,
  },
  {
    slug: 'zaixian-bangong',
    name: '在线办公',
    description: '云端协作办公套件，随时随地高效处理工作事务',
    icon: 'ri-computer-line',
    color: 'primary',
    featured: true,
  },
  {
    slug: 'shuzi-yule',
    name: '数字娱乐',
    description: '丰富的在线娱乐内容，游戏、音乐、互动体验一应俱全',
    icon: 'ri-gamepad-line',
    color: 'accent',
    featured: true,
  },
  {
    slug: 'yuncunchu',
    name: '云存储',
    description: '安全可靠的云端存储方案，海量数据轻松存取与管理',
    icon: 'ri-cloud-line',
    color: 'primary',
    featured: true,
  },
  {
    slug: 'anquan-fuwu',
    name: '安全服务',
    description: '全方位网络安全防护，保障您的数据与隐私安全无虞',
    icon: 'ri-shield-check-line',
    color: 'secondary',
    featured: true,
  },
  {
    slug: 'zhineng-gongju',
    name: '智能工具',
    description: 'AI驱动的智能工具集，提升工作效率与生活品质',
    icon: 'ri-robot-line',
    color: 'accent',
    featured: false,
  },
];

export const articles = [
  {
    slug: 'jiujiuzaixian-xinbanben-fabu',
    title: '久久在线全新版本正式发布，体验全面升级',
    summary: '久久在线服务平台迎来重大版本更新，全新界面设计、更快的响应速度和更多实用功能，为用户带来前所未有的在线服务体验。',
    content: `<p>经过数月精心打磨，<strong>久久在线</strong>全新版本正式与广大用户见面。本次更新围绕"更快、更稳、更智能"的核心理念，从底层架构到用户界面进行了全面升级。</p>
    <h2>性能全面提升</h2>
    <p>全新的分布式架构让久久在线的响应速度提升了<strong>300%</strong>，页面加载时间缩短至毫秒级别。无论您身处何地，都能享受流畅无卡顿的在线服务体验。</p>
    <h2>界面焕然一新</h2>
    <p>设计师团队倾力打造的全新界面，采用简约现代的设计语言，操作更加直观便捷。智能布局能够根据您的使用习惯自动调整，让每一项功能触手可及。</p>
    <h2>功能更加丰富</h2>
    <p>新增智能推荐引擎、多端同步播放记录、离线缓存等十余项实用功能，满足您在不同场景下的多样化需求。</p>
    <p>久久在线始终坚持以用户为中心，持续迭代优化产品体验。欢迎新老用户下载最新版本，感受久久在线带来的全新数字生活。</p>`,
    category: 'shipin-fuwu',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20digital%20service%20platform%20interface%20with%20clean%20minimal%20design%2C%20warm%20orange%20and%20cream%20color%20accents%2C%20futuristic%20yet%20professional%20atmosphere%2C%20soft%20natural%20lighting%2C%20abstract%20geometric%20shapes%20in%20background%2C%20editorial%20quality%20illustration%20style%20with%20smooth%20gradients&width=800&height=450&seq=article-cover-01&orientation=landscape',
    publishedAt: '2026-08-01',
    author: '久久在线编辑部',
    readTime: '5分钟',
    tags: ['版本更新', '产品发布', '久久在线'],
    featured: true,
  },
  {
    slug: 'ruhe-xuanze-shihe-nide-zaixian-fuwu',
    title: '如何选择适合您的在线服务平台？三大关键因素解析',
    summary: '面对众多在线服务平台，如何做出明智选择？本文从稳定性、安全性和功能丰富度三个维度，帮您找到最适合的久久在线服务方案。',
    content: `<p>在数字时代，选择一个靠谱的在线服务平台至关重要。<strong>久久在线</strong>为您梳理了选择在线服务平台的三大关键因素，帮助您做出明智决策。</p>
    <h2>因素一：稳定性</h2>
    <p>稳定的服务是在线体验的基石。久久在线采用<strong>多节点分布式架构</strong>，确保99.99%的服务可用性。即使在高并发场景下，也能保持流畅的响应速度。</p>
    <h2>因素二：安全性</h2>
    <p>数据安全不容忽视。久久在线采用<strong>银行级加密传输</strong>和多重身份验证机制，全方位保护用户数据与隐私安全。所有数据存储均符合国际安全标准。</p>
    <h2>因素三：功能丰富度</h2>
    <p>好的平台应当满足多样化需求。久久在线涵盖视频服务、在线办公、数字娱乐、云存储等六大核心功能模块，一个账号即可畅享全部服务。</p>
    <p>选择久久在线，就是选择专业、稳定、安全的在线服务体验。立即注册，开启您的数字化新生活。</p>`,
    category: 'zaixian-bangong',
    coverImage: 'https://readdy.ai/api/search-image?query=Professional%20business%20person%20analyzing%20data%20on%20digital%20screen%2C%20warm%20orange%20and%20cream%20tones%2C%20modern%20office%20setting%20with%20soft%20ambient%20lighting%2C%20clean%20minimalist%20aesthetic%2C%20abstract%20data%20visualization%20elements%2C%20editorial%20photography%20style&width=800&height=450&seq=article-cover-02&orientation=landscape',
    publishedAt: '2026-07-28',
    author: '久久在线编辑部',
    readTime: '8分钟',
    tags: ['平台选择', '服务对比', '使用指南'],
    featured: true,
  },
  {
    slug: 'yuncunchu-anquan-zhinan',
    title: '云存储安全指南：保护您的重要数据不被泄露',
    summary: '数据安全是云存储的核心关切。久久在线云存储服务通过多重安全机制，为您的数据提供全方位的保护。',
    content: `<p>随着云存储的普及，数据安全问题日益受到关注。<strong>久久在线云存储</strong>服务通过多种先进技术手段，确保您的数据安全无忧。</p>
    <h2>端到端加密</h2>
    <p>久久在线采用<strong>AES-256位加密标准</strong>，数据在传输和存储过程中全程加密，即使服务提供商也无法读取您的原始数据。</p>
    <h2>多副本冗余</h2>
    <p>所有文件自动备份至<strong>三个不同地理位置的服务器</strong>，即使某一节点发生故障，数据也不会丢失。</p>
    <h2>智能访问控制</h2>
    <p>支持精细化的权限管理，您可以精确控制每个文件夹的访问权限，确保敏感数据只被授权人员查看。</p>
    <p>选择久久在线云存储，让您的数据安全有保障。现在就上传您的第一个文件，体验安全便捷的云端存储服务。</p>`,
    category: 'yuncunchu',
    coverImage: 'https://readdy.ai/api/search-image?query=Secure%20cloud%20storage%20concept%20with%20digital%20lock%20and%20data%20icons%2C%20warm%20cream%20background%20with%20teal%20accents%2C%20abstract%20network%20connections%2C%20modern%20cybersecurity%20illustration%20style%2C%20soft%20gradients%20and%20geometric%20patterns&width=800&height=450&seq=article-cover-03&orientation=landscape',
    publishedAt: '2026-07-20',
    author: '久久在线技术团队',
    readTime: '6分钟',
    tags: ['云存储', '数据安全', '加密技术'],
    featured: true,
  },
  {
    slug: 'zaixian-bangong-xiaolv-tisheng',
    title: '在线办公效率提升的五大实用技巧',
    summary: '远程办公已成为常态，如何保持高效工作？久久在线为您总结了五个实用的在线办公效率提升方法。',
    content: `<p>远程办公时代，高效工作变得尤为重要。<strong>久久在线办公套件</strong>内置多种效率工具，结合以下五大技巧，让您的在线办公事半功倍。</p>
    <h2>技巧一：合理规划时间块</h2>
    <p>使用久久在线日历功能，将工作时间划分为<strong>专注时间块</strong>，每个时间块专注于一项任务，避免多任务切换造成的效率损失。</p>
    <h2>技巧二：善用协作工具</h2>
    <p>久久在线文档支持<strong>多人实时协作编辑</strong>，团队成员可以同步查看和修改文档，大幅减少来回沟通的时间成本。</p>
    <h2>技巧三：建立清晰的文件体系</h2>
    <p>在久久在线云存储中建立<strong>标准化的文件夹结构</strong>，让团队成员能够快速找到所需文件，告别混乱的文件管理。</p>
    <h2>技巧四：定期同步与复盘</h2>
    <p>利用久久在线视频会议功能，<strong>每日站会和每周复盘</strong>保持团队信息同步，确保项目按计划推进。</p>
    <h2>技巧五：善用自动化工具</h2>
    <p>久久在线智能工具提供<strong>工作流自动化</strong>功能，将重复性任务交给AI处理，释放更多时间进行创造性工作。</p>
    <p>掌握这些技巧，让久久在线助您轻松驾驭在线办公新时代。</p>`,
    category: 'zaixian-bangong',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20home%20office%20workspace%20with%20laptop%20and%20organized%20desk%2C%20warm%20natural%20lighting%2C%20plant%20on%20desk%2C%20clean%20minimal%20aesthetic%2C%20cream%20and%20warm%20wood%20tones%2C%20productivity%20concept%2C%20editorial%20photography%20style&width=800&height=450&seq=article-cover-04&orientation=landscape',
    publishedAt: '2026-07-15',
    author: '久久在线编辑部',
    readTime: '7分钟',
    tags: ['在线办公', '效率提升', '远程工作'],
    featured: false,
  },
  {
    slug: 'shuzi-yule-xin-qushi',
    title: '数字娱乐新趋势：沉浸式体验正在改变我们的休闲方式',
    summary: '从云游戏到互动直播，数字娱乐行业正迎来革命性变化。久久在线带您了解最新娱乐趋势，发现更多精彩内容。',
    content: `<p>数字娱乐行业正处于快速变革期，新技术不断刷新人们的娱乐体验。<strong>久久在线数字娱乐</strong>平台紧跟行业前沿，为您带来最潮流的娱乐方式。</p>
    <h2>云游戏时代来临</h2>
    <p>无需高性能硬件，通过久久在线云游戏平台，即可畅玩<strong>3A级大作</strong>。低延迟传输技术确保游戏体验流畅如本地运行。</p>
    <h2>互动直播升级</h2>
    <p>久久在线直播平台支持<strong>实时互动弹幕、虚拟礼物和多人连线</strong>功能，让观众与主播的距离前所未有地接近。</p>
    <h2>AI个性化推荐</h2>
    <p>基于深度学习的推荐算法，精准理解您的娱乐偏好，为您<strong>量身推荐</strong>最合适的音乐、视频和游戏内容。</p>
    <p>打开久久在线数字娱乐频道，发现属于您的精彩世界。</p>`,
    category: 'shuzi-yule',
    coverImage: 'https://readdy.ai/api/search-image?query=Immersive%20digital%20entertainment%20experience%20with%20colorful%20abstract%20visuals%2C%20warm%20orange%20and%20teal%20color%20scheme%2C%20gaming%20and%20streaming%20concept%2C%20modern%20futuristic%20illustration%20style%2C%20soft%20gradients%20and%20flowing%20light%20effects%2C%20dynamic%20composition&width=800&height=450&seq=article-cover-05&orientation=landscape',
    publishedAt: '2026-07-10',
    author: '久久在线编辑部',
    readTime: '5分钟',
    tags: ['数字娱乐', '云游戏', '互动直播'],
    featured: false,
  },
  {
    slug: 'jiujiuzaixian-anquan-tixi',
    title: '久久在线安全保障体系全面解读',
    summary: '安全是一切在线服务的基础。久久在线建立了多层次、全方位的安全保障体系，为用户数据保驾护航。',
    content: `<p>在网络安全形势日益严峻的今天，<strong>久久在线</strong>始终将安全放在首位，构建了行业领先的安全保障体系。</p>
    <h2>传输层安全</h2>
    <p>全站采用<strong>TLS 1.3加密协议</strong>，确保用户与服务器之间的数据传输不被窃听或篡改。同时部署DDoS防护系统，抵御大规模网络攻击。</p>
    <h2>存储层安全</h2>
    <p>用户数据使用<strong>AES-256加密存储</strong>，密钥定期轮换。数据库采用主从热备架构，确保数据持久性和高可用性。</p>
    <h2>应用层安全</h2>
    <p>实施<strong>OWASP Top 10安全标准</strong>，定期进行渗透测试和安全审计。支持双因素认证，防止账号被盗用。</p>
    <h2>合规认证</h2>
    <p>久久在线已通过<strong>ISO 27001信息安全管理体系认证</strong>和等保三级认证，安全能力获得权威认可。</p>
    <p>选择久久在线，您只需专注于业务发展，安全交给我们来守护。</p>`,
    category: 'anquan-fuwu',
    coverImage: 'https://readdy.ai/api/search-image?query=Cybersecurity%20shield%20concept%20with%20digital%20lock%20and%20protection%20symbols%2C%20warm%20cream%20background%20with%20subtle%20orange%20accents%2C%20abstract%20security%20network%20visualization%2C%20clean%20modern%20illustration%20style%2C%20professional%20corporate%20aesthetic%2C%20soft%20lighting&width=800&height=450&seq=article-cover-06&orientation=landscape',
    publishedAt: '2026-07-05',
    author: '久久在线安全团队',
    readTime: '6分钟',
    tags: ['安全保障', '数据加密', '合规认证'],
    featured: false,
  },
  {
    slug: 'AI-zhineng-gongju-shenghuo',
    title: 'AI智能工具如何改变我们的日常生活',
    summary: '人工智能正在悄然改变我们的生活方式。久久在线智能工具集让每个人都能享受AI带来的便利。',
    content: `<p>人工智能不再是科幻电影中的概念，它已经深度融入我们的日常生活。<strong>久久在线智能工具</strong>集成了多项AI能力，让科技服务于每个人的生活。</p>
    <h2>智能写作助手</h2>
    <p>久久在线AI写作工具能够帮助您<strong>快速生成高质量文案</strong>，无论是工作报告、营销文案还是创意写作，都能事半功倍。</p>
    <h2>图像处理工具</h2>
    <p>一键实现<strong>图片智能抠图、画质增强、风格转换</strong>等功能，无需专业设计技能，也能制作精美图片。</p>
    <h2>语音转文字</h2>
    <p>支持<strong>实时语音识别和多语言翻译</strong>，会议记录、采访整理等工作效率提升数倍。</p>
    <h2>智能日程管理</h2>
    <p>AI助手自动分析您的日程安排，<strong>智能推荐最优时间</strong>，避免时间冲突，让每一天都井井有条。</p>
    <p>久久在线智能工具，让AI成为您生活与工作的得力助手。</p>`,
    category: 'zhineng-gongju',
    coverImage: 'https://readdy.ai/api/search-image?query=AI%20artificial%20intelligence%20concept%20with%20digital%20brain%20and%20circuit%20patterns%2C%20warm%20orange%20and%20cream%20color%20scheme%2C%20abstract%20futuristic%20illustration%2C%20clean%20modern%20design%20with%20flowing%20data%20streams%2C%20soft%20gradient%20background%2C%20editorial%20quality&width=800&height=450&seq=article-cover-07&orientation=landscape',
    publishedAt: '2026-06-28',
    author: '久久在线编辑部',
    readTime: '7分钟',
    tags: ['AI工具', '智能生活', '科技趋势'],
    featured: false,
  },
  {
    slug: 'jiujiuzaixian-yonghu-gushi-zhangwei',
    title: '用户故事：张伟和他的远程创业团队',
    summary: '一位远程创业者的真实经历——如何利用久久在线的全套服务，打造高效协作的分布式团队。',
    content: `<p>张伟是一位连续创业者，他的团队分布在北京、上海、深圳三个城市。在使用<strong>久久在线</strong>之前，跨地域协作是最大的挑战。</p>
    <h2>痛点：协作效率低下</h2>
    <p>"我们需要同时使用视频会议、文档协作、文件存储等多个工具，来回切换不仅麻烦，还经常出现<strong>信息不同步</strong>的问题。"张伟回忆道。</p>
    <h2>转机：遇见久久在线</h2>
    <p>朋友推荐久久在线后，张伟的团队开始尝试使用。久久在线<strong>一站式集成</strong>了视频会议、在线文档、云存储和项目管理功能，团队不再需要切换多个平台。</p>
    <h2>成果：效率翻倍</h2>
    <p>"使用久久在线三个月后，我们的项目交付周期<strong>缩短了40%</strong>，团队成员满意度也大幅提升。"张伟说，"尤其是实时协作编辑功能，让远程评审方案变得像面对面一样高效。"</p>
    <p>如今，张伟的创业项目已经完成A轮融资，团队规模也从5人扩展到20人。久久在线伴随着他们一路成长。</p>`,
    category: 'zaixian-bangong',
    coverImage: 'https://readdy.ai/api/search-image?query=Happy%20remote%20team%20collaborating%20via%20video%20call%20on%20laptop%2C%20diverse%20professionals%20smiling%2C%20warm%20modern%20office%20setting%2C%20cream%20and%20warm%20wood%20tones%2C%20natural%20lighting%2C%20authentic%20teamwork%20atmosphere%2C%20editorial%20photography%20style&width=800&height=450&seq=article-cover-08&orientation=landscape',
    publishedAt: '2026-06-20',
    author: '久久在线编辑部',
    readTime: '6分钟',
    tags: ['用户故事', '远程办公', '团队协作'],
    featured: false,
  },
  {
    slug: 'gaoqing-shipin-bofang-jishu',
    title: '高清视频播放技术揭秘：流畅体验背后的硬核科技',
    summary: '久久在线视频服务是如何实现高清流畅播放的？本文为您揭秘背后的自适应码率、CDN加速等核心技术。',
    content: `<p>在久久在线观看高清视频时，您可能注意到画面始终<strong>清晰流畅、不卡顿</strong>。这背后是多项先进技术的协同运作。</p>
    <h2>自适应码率技术</h2>
    <p>久久在线采用<strong>HLS/DASH自适应流媒体协议</strong>，能够根据您的网络状况实时调整视频码率。网速快时自动切换到高清画质，网速波动时无缝降级，确保播放不中断。</p>
    <h2>全球CDN加速</h2>
    <p>久久在线在全球部署了<strong>超过200个加速节点</strong>，视频内容就近分发，大幅降低传输延迟。无论您身在何处，都能享受低延迟的流畅播放体验。</p>
    <h2>高效视频编码</h2>
    <p>采用<strong>H.265/HEVC先进编码标准</strong>，在同等画质下将视频文件体积缩小50%，既节省带宽又保证画质。</p>
    <h2>智能预加载</h2>
    <p>AI算法预测您的观看行为，提前加载<strong>接下来可能观看的内容</strong>，让视频切换几乎无等待。</p>
    <p>久久在线视频服务，用科技为您打造极致观影体验。</p>`,
    category: 'shipin-fuwu',
    coverImage: 'https://readdy.ai/api/search-image?query=High%20definition%20video%20streaming%20technology%20concept%20with%20digital%20play%20button%20and%20data%20flow%2C%20warm%20orange%20and%20cream%20color%20palette%2C%20abstract%20network%20visualization%2C%20modern%20tech%20illustration%20style%2C%20smooth%20flowing%20lines%20and%20geometric%20patterns%2C%20professional%20aesthetic&width=800&height=450&seq=article-cover-09&orientation=landscape',
    publishedAt: '2026-06-15',
    author: '久久在线技术团队',
    readTime: '8分钟',
    tags: ['视频技术', '高清播放', 'CDN加速'],
    featured: false,
  },
  {
    slug: 'chuxuezhe-jiujiuzaixian-ruMen',
    title: '初学者指南：三分钟快速上手久久在线',
    summary: '新用户必读！久久在线新手指南，手把手教您完成注册、配置和使用，三分钟开启您的在线服务之旅。',
    content: `<p>欢迎加入<strong>久久在线</strong>大家庭！本指南将带您快速了解久久在线的基本使用方法，让您三分钟内上手。</p>
    <h2>第一步：注册账号</h2>
    <p>访问久久在线官网，点击右上角<strong>"免费注册"</strong>按钮，输入手机号或邮箱即可完成注册。支持微信、支付宝一键快捷登录。</p>
    <h2>第二步：选择服务</h2>
    <p>登录后进入控制台，您可以看到<strong>视频服务、在线办公、云存储</strong>等六大核心模块。根据需求点击对应模块即可开始使用。</p>
    <h2>第三步：个性化设置</h2>
    <p>在设置中心，您可以<strong>自定义主题、通知偏好和隐私选项</strong>，让久久在线更符合您的使用习惯。</p>
    <h2>第四步：开始体验</h2>
    <p>一切准备就绪！现在您可以畅享久久在线提供的<strong>全部在线服务</strong>了。遇到问题可随时联系在线客服。</p>
    <p>久久在线，让数字生活更简单。</p>`,
    category: 'shipin-fuwu',
    coverImage: 'https://readdy.ai/api/search-image?query=Beginner%20friendly%20onboarding%20concept%20with%20hand%20touching%20digital%20interface%2C%20warm%20orange%20and%20cream%20tones%2C%20clean%20simple%20design%20elements%2C%20welcoming%20and%20approachable%20atmosphere%2C%20soft%20natural%20lighting%2C%20modern%20illustration%20style%20with%20step%20by%20step%20visual%20guide&width=800&height=450&seq=article-cover-10&orientation=landscape',
    publishedAt: '2026-06-10',
    author: '久久在线编辑部',
    readTime: '4分钟',
    tags: ['新手指南', '快速上手', '入门教程'],
    featured: false,
  },
  {
    slug: 'jiujiuzaixian-qiyeban-jieshao',
    title: '久久在线企业版：为企业量身定制的数字化解决方案',
    summary: '面向企业客户，久久在线推出企业版，提供定制化的在线服务解决方案，助力企业数字化转型。',
    content: `<p>随着企业数字化转型加速，<strong>久久在线企业版</strong>应运而生，为企业提供更专业、更安全、更高效的在线服务解决方案。</p>
    <h2>专属管理后台</h2>
    <p>企业版配备<strong>功能强大的管理后台</strong>，管理员可以统一管理员工账号、分配权限、查看使用统计，实现精细化管理。</p>
    <h2>高级安全保障</h2>
    <p>企业版提供<strong>SLA 99.99%服务保障、专属数据加密、审计日志</strong>等高级安全功能，满足企业对数据安全的严格要求。</p>
    <h2>定制化集成</h2>
    <p>支持与<strong>企业现有IT系统无缝对接</strong>，提供API接口和SSO单点登录，降低企业集成成本。</p>
    <h2>专属客户成功经理</h2>
    <p>每位企业客户配备<strong>专属客户成功经理</strong>，从方案设计到落地实施全程支持，确保产品价值最大化。</p>
    <p>久久在线企业版，为企业数字化转型保驾护航。联系销售团队获取专属方案。</p>`,
    category: 'zaixian-bangong',
    coverImage: 'https://readdy.ai/api/search-image?query=Enterprise%20digital%20transformation%20concept%20with%20modern%20corporate%20office%20building%20and%20digital%20network%2C%20warm%20orange%20and%20cream%20color%20scheme%2C%20professional%20business%20atmosphere%2C%20clean%20geometric%20patterns%2C%20abstract%20data%20visualization%2C%20editorial%20illustration%20style&width=800&height=450&seq=article-cover-11&orientation=landscape',
    publishedAt: '2026-06-05',
    author: '久久在线企业事业部',
    readTime: '7分钟',
    tags: ['企业版', '数字化转型', '企业服务'],
    featured: false,
  },
  {
    slug: 'yonghu-koubei-jiujiuzaixian',
    title: '真实口碑：听听久久在线用户怎么说',
    summary: '收集了来自不同行业用户的真实反馈，看看久久在线如何帮助他们解决实际问题，提升工作与生活品质。',
    content: `<p><strong>久久在线</strong>上线以来，已服务超过百万用户。我们收集了一些真实用户反馈，与您分享。</p>
    <blockquote><p>"久久在线的视频服务太流畅了，出差在外用手机也能高清观看，完全不卡顿！" <br/>— 李女士，市场总监</p></blockquote>
    <blockquote><p>"我们团队用久久在线办公套件后，协作效率至少提升了50%，推荐给所有远程团队。" <br/>— 王先生，创业公司CEO</p></blockquote>
    <blockquote><p>"云存储的空间够大，上传下载速度也快，而且价格比同类产品便宜不少。" <br/>— 赵同学，研究生</p></blockquote>
    <blockquote><p>"安全服务让我很放心，有一次账号异常登录立刻收到提醒，及时处理避免损失。" <br/>— 陈女士，自由职业者</p></blockquote>
    <p>久久在线始终以用户满意为最高追求，期待听到更多来自您的声音。</p>`,
    category: 'anquan-fuwu',
    coverImage: 'https://readdy.ai/api/search-image?query=Happy%20diverse%20group%20of%20users%20showing%20thumbs%20up%2C%20warm%20authentic%20portraits%2C%20cream%20and%20warm%20tone%20background%2C%20positive%20and%20trustworthy%20atmosphere%2C%20natural%20lighting%2C%20editorial%20photography%20style%2C%20clean%20composition&width=800&height=450&seq=article-cover-12&orientation=landscape',
    publishedAt: '2026-05-28',
    author: '久久在线编辑部',
    readTime: '5分钟',
    tags: ['用户口碑', '真实评价', '用户体验'],
    featured: true,
  },
];

export const brandInfo = {
  name: '久久在线',
  slogan: '随时随地，畅享在线服务',
  description: '久久在线成立于2018年，是国内领先的综合性在线服务平台。我们致力于为用户提供稳定、高速、全天候的在线服务体验，涵盖视频服务、在线办公、数字娱乐、云存储、安全服务和智能工具六大核心业务板块。',
  vision: '成为每个中国人数字生活的基础设施',
  mission: '让在线服务触手可及，让数字生活更美好',
  founded: '2018年',
  users: '100万+',
  employees: '500+',
  partners: '200+',
  milestones: [
    { year: '2018', title: '梦想起航', description: '久久在线正式成立，推出首款视频服务产品' },
    { year: '2019', title: '快速成长', description: '用户突破10万，新增在线办公和云存储服务' },
    { year: '2020', title: '逆势增长', description: '疫情期间服务用户量增长300%，推出安全服务模块' },
    { year: '2021', title: '产品矩阵', description: '完成六大产品线布局，服务覆盖全部核心业务' },
    { year: '2022', title: '技术突破', description: '自研分布式架构上线，服务可用性提升至99.99%' },
    { year: '2023', title: '用户破百万', description: '累计服务用户突破100万，企业客户超过5000家' },
    { year: '2024', title: 'AI赋能', description: '推出智能工具产品线，全面拥抱AI技术' },
    { year: '2025', title: '生态构建', description: '开放平台战略启动，构建久久在线服务生态' },
    { year: '2026', title: '全新升级', description: '品牌全面焕新，产品体验重大升级' },
  ],
  values: [
    { title: '用户至上', description: '一切以用户需求为中心，持续提升服务体验', icon: 'ri-heart-line' },
    { title: '技术驱动', description: '深耕核心技术，用创新推动产品不断进化', icon: 'ri-cpu-line' },
    { title: '安全可靠', description: '将数据安全视为生命线，建立全方位的保护体系', icon: 'ri-shield-star-line' },
    { title: '开放共赢', description: '拥抱开放生态，与合作伙伴共同成长', icon: 'ri-shake-hands-line' },
  ],
  team: [
    { name: '李明远', role: '创始人 & CEO', bio: '前阿里巴巴高级技术专家，15年互联网行业经验', image: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20man%20portrait%20photo%2C%20warm%20cream%20background%2C%20friendly%20confident%20smile%2C%20modern%20corporate%20headshot%2C%20clean%20minimal%20style%2C%20soft%20natural%20lighting%2C%20professional%20attire&width=160&height=160&seq=team-limingyuan&orientation=squarish' },
    { name: '王晓芳', role: '联合创始人 & CTO', bio: '前腾讯技术总监，分布式系统架构专家', image: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20woman%20portrait%20photo%2C%20warm%20cream%20background%2C%20friendly%20professional%20smile%2C%20modern%20corporate%20headshot%2C%20clean%20minimal%20style%2C%20soft%20natural%20lighting&width=160&height=160&seq=team-wangxiaofang&orientation=squarish' },
    { name: '陈思远', role: 'COO', bio: '前华为云运营总监，10年企业管理经验', image: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20man%20portrait%20photo%2C%20warm%20cream%20background%2C%20friendly%20approachable%20smile%2C%20modern%20corporate%20headshot%2C%20clean%20minimal%20style%2C%20soft%20natural%20lighting&width=160&height=160&seq=team-chensiyuan&orientation=squarish' },
    { name: '赵雪琳', role: 'CPO', bio: '前字节跳动产品负责人，用户体验设计专家', image: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20woman%20portrait%20photo%2C%20warm%20cream%20background%2C%20friendly%20creative%20smile%2C%20modern%20corporate%20headshot%2C%20clean%20minimal%20style%2C%20soft%20natural%20lighting&width=160&height=160&seq=team-zhaoxuelin&orientation=squarish' },
  ],
  contact: {
    phone: '400-888-9999',
    email: 'contact@jiujiuzaixian.com',
    address: '北京市海淀区中关村科技园区创新路88号久久大厦',
    wechat: '久久在线',
    weibo: '@久久在线官方',
  },
};

export const faqs = [
  {
    question: '久久在线是免费的吗？',
    answer: '久久在线提供免费基础版供个人用户体验，包含视频服务、云存储基础功能和在线办公基础功能。如需更多高级功能和更大存储空间，可选择我们的专业版或企业版套餐。',
  },
  {
    question: '久久在线支持哪些设备？',
    answer: '久久在线支持全平台使用，包括Windows、macOS、iOS、Android等主流操作系统，同时提供Web网页版，无需安装即可使用。所有设备间数据实时同步。',
  },
  {
    question: '久久在线的视频播放画质如何？',
    answer: '久久在线视频服务支持最高4K超高清画质播放，采用自适应码率技术，根据您的网络状况自动调整最佳画质，确保流畅不卡顿的观看体验。',
  },
  {
    question: '如何保障我的数据安全？',
    answer: '久久在线采用银行级AES-256加密技术，数据传输全程使用TLS 1.3加密协议。同时通过ISO 27001安全认证和等保三级认证，建立了完善的数据安全管理体系。',
  },
  {
    question: '久久在线支持企业定制吗？',
    answer: '支持！久久在线企业版提供专属管理后台、API接口、SSO单点登录等功能，可以根据企业需求进行深度定制。欢迎联系我们的企业服务团队获取专属方案。',
  },
  {
    question: '遇到问题如何联系客服？',
    answer: '您可以通过在线客服、官方邮箱contact@jiujiuzaixian.com、客服热线400-888-9999等多种渠道联系我们。我们的客服团队7×24小时为您提供专业支持。',
  },
];

export const features = [
  {
    title: '稳定可靠',
    description: '99.99%服务可用性保障，多节点分布式架构，确保服务永不掉线',
    icon: 'ri-server-line',
    color: 'primary',
  },
  {
    title: '极速体验',
    description: '全球CDN加速网络，毫秒级响应速度，流畅无卡顿的使用体验',
    icon: 'ri-speed-up-line',
    color: 'accent',
  },
  {
    title: '安全无忧',
    description: '银行级加密传输，多重身份验证，全方位守护您的数据安全',
    icon: 'ri-shield-keyhole-line',
    color: 'primary',
  },
  {
    title: '全天候服务',
    description: '7×24小时不间断运行，专业客服团队随时待命，解决问题不等待',
    icon: 'ri-24-hours-line',
    color: 'accent',
  },
  {
    title: '多端同步',
    description: '支持全平台使用，数据实时云端同步，随时随地无缝切换设备',
    icon: 'ri-smartphone-line',
    color: 'primary',
  },
  {
    title: '智能推荐',
    description: 'AI深度学习算法，精准理解您的偏好，为您推荐个性化内容',
    icon: 'ri-brain-line',
    color: 'accent',
  },
];